import mrApi from './mrApi';

export function getWidgetLoadingMode(params) {
  return mrApi.get('/api/zendesk/getWidgetLoadingMode', { params });
}
